import { render, staticRenderFns } from "./RidershipIntervalToggle.vue?vue&type=template&id=c5c823b0&scoped=true"
import script from "./RidershipIntervalToggle.vue?vue&type=script&lang=js"
export * from "./RidershipIntervalToggle.vue?vue&type=script&lang=js"
import style0 from "./RidershipIntervalToggle.vue?vue&type=style&index=0&id=c5c823b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c823b0",
  null
  
)

export default component.exports